export class Skim {
  constructor (text, callback, options) {
    this.text = text
    this.callback = callback
    this.options = {
      speed: 250,
      ...options
    }
  }

  ORP (word) {
    let length = word.length
    while ('\n,.?!:;"'.indexOf(word[--length]) !== -1);
    switch (++length) {
      case 0:
      case 1:
        return 0
      case 2:
      case 3:
        return 1
      default:
        return Math.floor(length / 2) - 1
    }
  }

  createWord (word) {
    const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g
    const split = this.ORP(word)
    const length = word.length
    let lpad = ''
    let rpad = ''

    if (length == 2) {
      rpad = this.pad('\u00A0', 1)
    } else if (length == 1 || length == 3) {
      rpad = this.pad('\u00A0', 0)
    } else if (length % 2) {
      lpad = this.pad('\u00A0', Math.floor(length / 2) - split + 1)
    } else {
      lpad = this.pad('\u00A0', Math.floor(length / 2) - split)
    }

    const result = document.createElement('div')
    result.style['text-align'] = 'center'
    result.appendChild(document.createTextNode(lpad))

    const left = document.createElement('span')
    left.appendChild(document.createTextNode(lpad + word.substr(0, split)))
    result.appendChild(left)

    const highlight = document.createElement('span')
    highlight.style.color = 'red'
    highlight.appendChild(document.createTextNode(word.substr(split, 1)))
    result.appendChild(highlight)

    const right = document.createElement('span')
    right.appendChild(document.createTextNode(word.substr(split + 1) + rpad))
    result.appendChild(right)
    return result
  }

  pad (string, count) {
    let result = ''
    while (count--) result += string
    return result
  }

  * iterateOverArray (arr) {
    let i = 0
    while (i < arr.length) {
      yield arr[i++]
    }
  }

  async read (words) {
    const generator = await this.iterateOverArray(words)

    var interval = setInterval(() => {
      const nxt = generator.next()
      if (!nxt || nxt.done) {
        clearTimeout(interval)
      } else {
        this.callback(this.createWord(nxt.value))
      }
    }, this.options.speed)
  }

  start () {
    const words = this.text.split(' ')
    this.read(words)
  }
}
